var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"sort-by":"revision.date_created","headers":_vm.headers,"items":_vm.items,"items-per-page":15}})}
var staticRenderFns = []

export { render, staticRenderFns }